import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  unauthorize,
  updateFilter,
  cleanFilter,
  addCoordinatesProblems,
  getCoordinatesResult,
  downloadProblems,
  updateOrganizationsNames,
  updateCustomer
} from '../sagas/actions';
import { Grid, LinearProgress } from '@material-ui/core';
import ProblemsTable from './components/ProblemsTable';
import DailyProcessInfo from './components/DailyProcessInfo';
import NavBar from './components/NavBar';
import Filter from './components/Filter';
import ProblemsStats from './components/ProblemsStats';

class Main extends Component {
  logout = () => {
    this.props.dispatch(unauthorize());
  };

  updateFilter = (filter) => {
    this.props.dispatch(updateFilter(filter));
  }

  updateFilterOrder = (order, orderByField) => {
    this.props.dispatch(updateFilter({ ...this.props.filter, order, orderByField }));
  }

  cleanFilter = () => {
    this.props.dispatch(cleanFilter());
  }

  addCoordinatesProblems = () => {
    this.props.dispatch(addCoordinatesProblems(this.props.filter));
  }

  getCoordinatesResult = (serial, createdDate) => {
    this.props.dispatch(getCoordinatesResult(serial, createdDate, this.props.filter.customer));
  }

  downloadProblems = () => {
    this.props.dispatch(downloadProblems(this.props.filter));
  }

  updateOrganizationsNames = organizationsNames => {
    this.props.dispatch(updateOrganizationsNames(organizationsNames));
  }

  updateCustomer = customer => {
    this.props.dispatch(updateCustomer(customer));
  }

  render() {
    const {
      token,
      name,
      filter,
      coordinatesProblems,
      dataLoading,
      filterLoading,
      dailyInfo,
      problemsStats,
      lastProblemsProcessInfo
    } = this.props;
    
    if (!token) {
      return <Redirect to="/login" />;
    }

    return (
      <Grid>
        {dataLoading && <div style={{flexGrow: 1, position: 'sticky', top: 0}}>
          <LinearProgress />
        </div>}
        <NavBar name={name} logout={this.logout} />
        <Filter 
          updateFilter={this.updateFilter}
          cleanFilter={this.cleanFilter}
          filter={filter}
          loading={filterLoading}
          updateOrganizationsNames={this.updateOrganizationsNames}
          updateCustomer={this.updateCustomer}
        />
        <ProblemsStats problemsStats={problemsStats} />
        <ProblemsTable
          order={filter.order}
          orderByField={filter.orderByField}
          updateFilterOrder={this.updateFilterOrder}
          coordinatesProblems={coordinatesProblems}
          addCoordinatesProblems={this.addCoordinatesProblems}
          getCoordinatesResult={this.getCoordinatesResult}
          downloadProblems={this.downloadProblems}
          lastProcessDate={lastProblemsProcessInfo}
        />
        <DailyProcessInfo dailyInfo={dailyInfo} />
      </Grid>
    );
  }
}

const mapStateToProps = state => ({
  token: state.auth.token,
  name: state.auth.name,
  filter: state.filter,
  coordinatesProblems: state.upaData.coordinatesProblems,
  dataLoading: state.upaData.loading,
  filterLoading: state.filter.options.loading,
  dailyInfo: state.upaData.dailyInfo,
  problemsStats: state.upaData.problemsStats,
  lastProblemsProcessInfo: state.upaData.lastProblemsProcessInfo
});

export default connect(mapStateToProps)(Main);


// WEBPACK FOOTER //
// ./src/main/Main.jsx